import React from 'react';
import { useTranslation } from 'react-i18next';


const ReceiptHeader = ({receipt}:any) => {
    const {t} = useTranslation();
    return(
        <div className="mb-3">
            <div><strong>{t('Receipt.store')}:</strong> {receipt.store.name}</div>
            <div><strong>{t('Receipt.title')}</strong> #{receipt.receiptNumber}</div>
            <div><strong>{t('Receipt.cashier')}:</strong> {receipt.cashier}</div>
            <div><strong>{t('Receipt.checkout')}:</strong> {receipt.checkout}</div>
            <div><strong>{t('Receipt.date')}:</strong> {receipt.date}</div>
        </div>
    )
}
export default ReceiptHeader;